export default {
  labels: {
    sold_out: 'Esaurito!',
    most_popular: '#{{rank}} Più apprezzato',
    last_ordered: 'Ultimo ordinato',
  },
};
